module.exports = __webpack_public_path__ + "img/search-f.ee9f63b7.svg";